import React, { useMemo } from "react";
import backgroundVideo from "../images/homepage/video/homepage_hero_video.mp4";

const HomeHeroSection = (props) => {
  const memoizedContent = useMemo(
    () => (
      <div className="container-fluid">
        <div className="hero_inner_section text-center">
          <div>
            <h1>
              <span>{props.title}</span> {props.subtitle}
            </h1>
            {/* <h3 style={{color: "white"}}>We are currently migrating from our old API to the new version. If you encounter any issues related to valuation, please contact us at sonalit@codeplateau.com, Krishnad@codeplateau.com Thank you for your understanding during this transition.</h3> */}
          </div>
        </div>
      </div>
    ),
    [props.title, props.subtitle]
  );

  return (
    <section
      className="home_hero_section d-flex justify-content-center align-items-center"
      id="hero_section"
    >
      <video autoPlay muted loop playsInline className="background-video">
        <source src={backgroundVideo} type="video/mp4" />
      </video>
      {memoizedContent}
    </section>
  );
};

export default HomeHeroSection;
